<template>
  <div id="app">
    <AuthShell v-if="!isAuthenticated" @authenticated="handleAuthenticated" />
    <AdminWorkspace
      v-else-if="session.user.role === 2"
      :session="session"
      @logout="logout"
      @session-updated="updateSession"
    />
    <EmployeeWorkspace
      v-else-if="session.user.role === 3"
      :session="session"
      @logout="logout"
      @session-updated="updateSession"
    />
    <div v-else class="fallback-panel">
      <el-result icon="warning" title="当前角色未开放演示">
        <template #extra>
          <el-button type="primary" @click="logout">返回登录页</el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
import AdminWorkspace from './components/AdminWorkspace.vue'
import AuthShell from './components/AuthShell.vue'
import EmployeeWorkspace from './components/EmployeeWorkspace.vue'
import { SESSION_KEY } from './constants/storage'
import { hasValidSession, normalizeSessionPayload } from './utils/session'

export default {
  name: 'App',
  components: {
    AdminWorkspace,
    AuthShell,
    EmployeeWorkspace
  },
  data() {
    return {
      session: null
    }
  },
  computed: {
    isAuthenticated() {
      return hasValidSession(this.session)
    }
  },
  mounted() {
    window.addEventListener('auth:logout', this.logout)
    const raw = window.localStorage.getItem(SESSION_KEY)

    if (!raw || raw === 'undefined' || raw === 'null') {
      return
    }

    try {
      const session = normalizeSessionPayload(JSON.parse(raw))

      if (!hasValidSession(session)) {
        this.logout()
        return
      }

      this.session = session
    } catch (error) {
      this.logout()
    }
  },
  beforeUnmount() {
    window.removeEventListener('auth:logout', this.logout)
  },
  methods: {
    handleAuthenticated(payload) {
      const session = normalizeSessionPayload(payload)

      if (!hasValidSession(session)) {
        this.logout()
        return
      }

      this.session = session
      window.localStorage.setItem(SESSION_KEY, JSON.stringify(session))
    },
    updateSession(payload) {
      const session = normalizeSessionPayload({
        token: payload?.token || this.session?.token,
        user: payload?.user,
        company: payload?.company || this.session?.company
      })

      if (!hasValidSession(session)) {
        this.logout()
        return
      }

      this.session = session
      window.localStorage.setItem(SESSION_KEY, JSON.stringify(session))
    },
    logout() {
      this.session = null
      window.localStorage.removeItem(SESSION_KEY)
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  min-height: 100vh;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #0f172a;
}

body {
  background: #f8fafc;
}

.fallback-panel {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
